import palette from '../palette';

export default {
  underline: {
    '&:after': {
      borderBottom: "2px solid ".concat(palette.primary.highlight)
    }
  }
};
